import { QuoteType } from 'quotes/enums';

import { ItemsToCopyField } from './enums';

export const getItemsToCopyValues = (
  fromQuoteType = QuoteType.CUSTOMER,
  toQuoteType = QuoteType.CUSTOMER
) => {
  switch (fromQuoteType) {
    case QuoteType.VENDOR:
      return getItemsToCopyValuesForVendor(toQuoteType);
    case QuoteType.CUSTOMER:
    default:
      return getItemsToCopyValuesForCustomer(toQuoteType);
  }
};

const getItemsToCopyValuesForVendor = (toQuoteType = QuoteType.CUSTOMER) => {
  switch (toQuoteType) {
    case QuoteType.VENDOR:
      return [
        ItemsToCopyField.PARTS,
        ItemsToCopyField.QUANTITIES,
        ItemsToCopyField.UOMS,
        ItemsToCopyField.LINE_NOTES,
        ItemsToCopyField.QUOTE_CUSTOMER_NOTE,
      ];
    case QuoteType.CUSTOMER:
      return [
        ItemsToCopyField.PARTS,
        ItemsToCopyField.QUANTITIES,
        ItemsToCopyField.UOMS,
        ItemsToCopyField.LINE_NOTES,
      ];
    default:
      return [];
  }
};

const getItemsToCopyValuesForCustomer = (fromQuoteType = QuoteType.CUSTOMER) => {
  switch (fromQuoteType) {
    case QuoteType.VENDOR:
      return [
        ItemsToCopyField.PARTS,
        ItemsToCopyField.QUANTITIES,
        ItemsToCopyField.UOMS,
        ItemsToCopyField.LINE_NOTES,
      ];
    case QuoteType.CUSTOMER:
      return Object.values(ItemsToCopyField);
    default:
      return [];
  }
};
